import {NotePencilRegularIcon} from 'shells/icon/svg/note-pencil-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {RichTextDisplay} from '../../../rich-text-display/rich-text-display';

import {HOVERVIEW_ORIENTATION} from '../../../../../../../ui/core-entity/rows/peep-rows/types';

import {getFormattedTimestampForChannelEvent} from '../../helpers';

import styles from './notes-banner.module.css';

interface Props {
    changeTime: string;
    note: string;
    creatorName: string;
}

export function NotesBanner(props: Props) {
    return (
        <div
            className='mb-16 mt-8 flex full-width justify-end'
            data-orientation-override={HOVERVIEW_ORIENTATION.WEST}
        >
            <Stack spacing={8} alignItems='end' isFullWidth={false}>
                <Body size='small' color='light' textAlign='right'>
                    <span className='flex align-center justify-end'>
                        <NotePencilRegularIcon size={14} className='mr-4' alignCenter={true} />
                        <Body as='span' size='small' color='dark' isBold={true}>
                            {props.creatorName}
                        </Body>
                        &nbsp;added a note ·&nbsp;
                        {getFormattedTimestampForChannelEvent(props.changeTime)}
                    </span>
                </Body>
                <div className={styles['note-box']}>
                    <RichTextDisplay size='small' html={props.note} />
                </div>
            </Stack>
        </div>
    );
}
